// src/api/mockData.js
export let users = [
  {
    id: 1,
    username: '文物守护者',
    password: '123456',
    name: '文物守护者',
    avatar: 'hhttps://via.placeholder.com/150/C03B3B/ffffff?text=文',
    intro: '以文为心，以物为言，守护千年记忆',
    email: 'guardian@cultural.com',
    role: 'admin'
  }
];

export let posts = [
  {
    id: '1766735622630',
    title: '青铜鼎：三千年的沉默与诉说',
    author: '文物守护者',
    date: '2025-12-26 15:53:42',
    tags: ['青铜器', '商周', '礼器'],
    summary: '当月光洒在斑驳的铜绿上，我仿佛能听见三千年前的祭祀钟声。作为权力的象征，我见证了王朝更迭，也承载了先民的信仰。',
    content: `# 青铜鼎：三千年的沉默与诉说

## 一、我的诞生

我是**司母戊鼎**，诞生于商朝晚期。在那个青铜时代，我被赋予神圣的使命——连接天地，沟通人神。

## 二、纹饰的密码

我身上的饕餮纹、云雷纹，不是简单的装饰：
- 饕餮纹代表威严与权力
- 云雷纹象征天地循环
- 夔龙纹寓意王权神授

## 三、历史的见证

我见证了：
- 商王武丁的祭祀大典
- 周武王的分封仪式
- 历代王朝的礼仪变革

> "国之大事，在祀与戎"——《左传》

## 四、今日之我

如今，我在博物馆里静默伫立。当您凝视我的纹饰，触摸历史的温度，便能听见三千年前的回响。`
  },
  {
    id: '1766735622631',
    title: '青花瓷：一抹钴蓝的千年诗篇',
    author: '文物守护者',
    date: '2025-12-25 10:30:15',
    tags: ['瓷器', '元代', '青花'],
    summary: '素胚勾勒出青花笔锋浓转淡，瓶身描绘的牡丹一如你初妆。我用钴蓝书写东方美学，跨越时空与你对话。',
    content: `# 青花瓷：一抹钴蓝的千年诗篇

## 青花之美

青花瓷，以钴为墨，以瓷为纸，在高温中绽放永恒的美。

## 工艺特点

1. **钴料发色**：天然钴矿，经高温还原焰呈青蓝色
2. **透明釉**：使青花纹饰清晰可见
3. **高岭土**：景德镇优质瓷土，胎质细腻

## 文化意义

青花瓷不仅是生活器皿，更是：
- 东西方文化交流的见证
- 海上丝绸之路的重要商品
- 中国美学的国际名片`
  }
];

// 添加文章管理函数
export const addPost = (post) => {
  posts = [post, ...posts];
  return posts;
};

export const getPostById = (id) => {
  return posts.find(post => post.id === id);
};

export const deletePost = (id) => {
  posts = posts.filter(post => post.id !== id);
  return posts;
};

export const updatePost = (id, updatedPost) => {
  const index = posts.findIndex(post => post.id === id);
  if (index !== -1) {
    posts[index] = { ...posts[index], ...updatedPost };
  }
  return posts;
};

export const defaultAboutInfoTemplate = {
  name: '文物守护者',
  avatar: 'https://via.placeholder.com/150/C03B3B/ffffff?text=文',
  intro: '以文为心，以物为言，守护千年记忆',
  details: '欢迎来到文物博客！在这里，每一件文物都有自己的故事，每一次凝视都是与历史的对话。',
  email: 'guardian@cultural.com',
  techStack: '文物保护 | 历史研究 | 文化传播',
  interests: '青铜器研究 | 瓷器鉴赏 | 古文字学',
  github: '#',
  linkedin: '#',
  personalHomepage: '#'
};